import { useQuery } from '@tanstack/react-query';

import { transformDataBuilderResults } from '../datasets/api-transform';
import { fetchDataBuilderResults } from './data-builder-api';

export const useDataBuilderQuery = () =>
  useQuery({
    queryKey: ['data-builder'],
    queryFn: fetchDataBuilderResults,
    select: transformDataBuilderResults,
  });
